<template>
  <div class="base-wrapper container wrapper pay-result-container">
    <!-- 头部标题 -->
    <headline
      :params="headerData"
      :show-error="false"
    ></headline>
    <div class="scroll-container">
      <!-- 心智区域 -->
      <noema-area
        v-if="showNoemaArea"
        :mind-data="mindData"
        @openDiscountPage="openDiscountPage"
      />
      <adx
        v-if="showAdx"
        :adx-data="adxData"
      />
    </div>

    <!-- 底部按钮区域 -->
    <div class="container-bottom-info absolute-bottom">
      <div
        v-if="orderButton.text"
        class="button-line"
      >
        <button @click="clickButton">
          {{ orderButton.text }}
        </button>
        <div
          v-if="orderButton.bubble"
          class="badge ellipsis"
        >
          {{ orderButton.bubble }}
        </div>
      </div>
      <div
        v-if="buttonText"
        class="button-line"
      >
        <button
          :class="btnClass"
          @click="toPayClickButton"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { env } from '@/common';
import NoemaArea from './NoemaArea.vue';
import { lx } from '@/analytic';
import { cids, bids } from '@/analytic/lx-constants';
import Headline from '@/views/components/Headline.vue';
import { payFailButtonClick } from '@/service/queryOrder';

export default Vue.extend({
  name: 'App',

  components: {
    NoemaArea,
    Headline,
    Adx: () => import(/* webpackChunkName: 'adx' */ './Adx.vue'),
  },
  data() {
    return {
      isLargeHeightPage: env.getIsLargeHeightPage(),
      pageData: this.$store.state.result.resultData as PageData,
      payFailAction: env.payFailAction,
    };
  },
  computed: {
    headerData(): HeaderDataType {
      return {
        title: this.transInfo.pageTitle,
        sub_title: this.transInfo.subPageTitle,
      };
    },
    transInfo(): TransInfoType {
      return this.pageData.dynamicLayout?.jsData?.transInfo || {};
    },

    note(): NoteType {
      return this.pageData.dynamicLayout?.jsData?.note;
    },
    orderButton(): OrderButtonType {
      return this.pageData.dynamicLayout?.jsData?.orderButton || {};
    },

    buttonText(): string {
      return this.pageData.dynamicLayout?.jsData?.button;
    },

    mindData(): MindType {
      return this.pageData.dynamicLayout?.jsData?.mind || {};
    },

    showNotify(): boolean {
      return !!this.mindData.notify?.list?.length;
    },

    // 展示心智模块
    showNoemaArea(): boolean {
      return !!this.mindData.notify;
    },

    businessType(): string {
      return this.pageData.dynamicLayout?.jsData?.others?.businessType || '-999';
    },
    adxData(): any {
      return this.pageData.dynamicLayout?.jsData?.adx || {};
    },
    // 展示adx内容
    showAdx(): boolean {
      return !!(this.adxData?.spaceAdxDTO?.spaceHitAds?.length && this.adxData?.more?.lionConfig);
    },
    btnClass(): string {
      return this.orderButton?.text ? 'gray-btn' : '';
    },
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      // 设置灵犀通用参数
      env.setResultLxCommonParams(this.pageData.dynamicLayout?.jsData, 'payDefer');
      lx.pv(cids.result, {
        bussiness_type: this.businessType,
        scorePlanId: env.coreBusinessParams.scorePlanId,
      });
    },
    clickButton() {
      this.clickButtonMc(this.orderButton.text);
      payFailButtonClick();
    },
    openDiscountPage() {
      // 本期没有优惠明细及返赠明细，预留坑位
    },
    toPayClickButton() {
      this.clickButtonMc(this.buttonText);
      payFailButtonClick();
    },
    clickButtonMc(buttonText: string) {
      lx.mc(bids.deferGoPay.mc, {
        bussiness_type: this.businessType,
        button_name: buttonText,
        scorePlanId: env.coreBusinessParams.scorePlanId,
      });
    },
  },
});
</script>

<style lang="less" scoped>
.pay-result-container {
  position: relative;
  text-align: center;
  background: #f7f7f7;
  height: 100%;
  padding: 0 0.36rem;

  .scroll-container {
    width: 100%;
    height: calc(100% - 2.58rem);
    padding-bottom: 2.58rem;
    overflow-y: auto;
  }
  .title {
    line-height: 0.66rem;
    font-size: 0.48rem;
    font-weight: bold;
    color: #222;
    padding-top: 0.63rem;
  }

  .sub-title {
    line-height: 0.42rem;
    font-size: 0.24rem;
    color: #666;
    padding-bottom: 0.51rem;
  }

  i.icon-error {
    position: absolute;
    top: 0.52rem;
    right: 0.52rem;
    font-size: 0.24rem;
    font-weight: bold;
    color: #a6a6a6;
  }

  /deep/ .noema-wrapper {
    text-align: left;
    margin-top: 0;
    margin-bottom: 0.18rem;
  }
  /deep/ .container-bottom-info {
    background: #f7f7f7;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
